/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Hint_ZoomInputs */

const en_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zoom`)
};

const ar_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكبير`)
};

const bn_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জুম`)
};

const de_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom`)
};

const es_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zoom`)
};

const fr_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zoom`)
};

const pt_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zoom`)
};

const zh_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩放`)
};

const tr_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yakınlaştırma`)
};

const ru_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`масштаб`)
};

const pl_image_inspector_hint_zoom = /** @type {(inputs: Image_Inspector_Hint_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powiększenie`)
};

/**
* | output |
* | --- |
* | "zoom" |
*
* @param {Image_Inspector_Hint_ZoomInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_hint_zoom = /** @type {((inputs?: Image_Inspector_Hint_ZoomInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Hint_ZoomInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_hint_zoom(inputs)
	if (locale === "bn") return bn_image_inspector_hint_zoom(inputs)
	if (locale === "de") return de_image_inspector_hint_zoom(inputs)
	if (locale === "es") return es_image_inspector_hint_zoom(inputs)
	if (locale === "fr") return fr_image_inspector_hint_zoom(inputs)
	if (locale === "pt") return pt_image_inspector_hint_zoom(inputs)
	if (locale === "zh") return zh_image_inspector_hint_zoom(inputs)
	if (locale === "tr") return tr_image_inspector_hint_zoom(inputs)
	if (locale === "ru") return ru_image_inspector_hint_zoom(inputs)
	if (locale === "pl") return pl_image_inspector_hint_zoom(inputs)
	return en_image_inspector_hint_zoom(inputs)
});